import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { API_MFI_URL } from "constants/config"
import { authBaseQuery } from "../api"

if (!API_MFI_URL) {
  throw new Error("REACT_APP_API_MFI_URL is not defined")
}

export const mfiApi = createApi({
  reducerPath: "mfiApi",
  baseQuery: authBaseQuery(API_MFI_URL),
  tagTypes: ["SurveysMFI", "BaseXlsFormMFI", "XlsFormMFI", "BaseSchemasMFI", "XlsFormSchemaMFI"],
  endpoints: () => ({}),
})
